import React, {
  FC, useRef, useState,
} from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Tabs, Pagination, Typography } from "@trussle/external-components";
import cn from "classnames";
import { ISplashPanelProps } from "../OriginalSplashPanel";
import { CategoryToColourMap } from "../../../../types/common";
import { IBlock } from "../../../../types/IBlock";
import "./style.scss";
import ArticleCard from "../../../ArticleCard";
import { PanelWrapper } from "../../../PanelWrapper";

const articlesQuery = graphql`
    query {
        allContentfulBlock(filter: {variant: {eq: "ArticleCard"}}) {
            nodes {
                id
                title
                subtitle
                content {
                    raw
                }
                link {
                    text
                    url
                }
                category
            }
        }
    }
`;

export const ARTICLES_PER_PAGE = 8;
const CATEGORY_ALL = "All";

const articleCategories = [CATEGORY_ALL, ...Object.keys(CategoryToColourMap)];

export const ListOfArticlesSplashPanel: FC<ISplashPanelProps> = ({ betterV2 }) => {
  const { allContentfulBlock: { nodes: articles } }: {
    allContentfulBlock: { nodes: IBlock[] }
  } = useStaticQuery(articlesQuery);
  const [filteredArticles, setFilteredArticles] = useState(articles);
  const [currentIndex, setCurrentIndex] = useState(0);
  const numberOfPages = useRef(Math.ceil(articles.length / ARTICLES_PER_PAGE));

  const filterArticles = (category: string) => {
    let newFilteredArticles;
    if (category === CATEGORY_ALL) {
      newFilteredArticles = articles;
    } else {
      newFilteredArticles = articles.filter((article) => article.category === category);
    }
    numberOfPages.current = Math.ceil(newFilteredArticles.length / ARTICLES_PER_PAGE);
    setCurrentIndex(0);
    setFilteredArticles(newFilteredArticles);
  };

  const decrementIndex = () => {
    setCurrentIndex((prevPage) => prevPage - 1);
  };

  const incrementIndex = () => {
    setCurrentIndex((prevPage) => prevPage + 1);
  };

  return (
    <PanelWrapper isBetterV2={betterV2}>
      <Typography variant="body2">Filter by</Typography>
      <Tabs className="listOfArticlesSplashPanel-filters" tabs={articleCategories} onTabClick={filterArticles} betterV2={betterV2} />
      <div className={cn("listOfArticlesSplashPanel-articles", { betterV2 })}>
        {filteredArticles.map((article, index) => {
          if ((index >= currentIndex * ARTICLES_PER_PAGE) && (index < ((currentIndex * ARTICLES_PER_PAGE) + ARTICLES_PER_PAGE))) {
            return (
              <ArticleCard
                key={article.id}
                title={article.title}
                content={article.content}
                subTitle={article.subtitle ?? ""}
                linkText={article.link?.text ?? ""}
                linkURL={article.link?.url ?? "#"}
                betterV2={betterV2}
              />
            );
          }

          return null;
        })}
      </div>
      <Pagination
        className="listOfArticlesSplashPanel-pagination"
        currentPage={currentIndex + 1}
        numberOfPages={numberOfPages.current}
        onPreviousClick={decrementIndex}
        onNextClick={incrementIndex}
      />
    </PanelWrapper>
  );
};
